"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _OldButton = _interopRequireDefault(require("../OldButton"));

var _reactNative = require("react-native");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ModalContent(props) {
  let {
    title,
    back,
    dismiss,
    hasContentPadding = true
  } = props;
  let hasTitleBar = title || back || dismiss;
  return /*#__PURE__*/_react.default.createElement(Container, {
    refScrollView: props.refScrollView
  }, hasTitleBar && /*#__PURE__*/_react.default.createElement(_Stack.default, {
    p: "m",
    distribution: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, null, back && /*#__PURE__*/_react.default.createElement(_OldButton.default, {
    onPress: back,
    size: "s"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "secondary.main"
  }, "\u0628\u0627\u0632\u06AF\u0634\u062A"))), title && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    ff: "mainBold"
  }, title), /*#__PURE__*/_react.default.createElement(_Box.default, null)), /*#__PURE__*/_react.default.createElement(_Box.default, null, props.children));
}

const webStyles = _reactNative.Platform.OS === "web" ? {
  container: {
    maxWidth: 768,
    marginRight: "auto",
    marginLeft: "auto",
    width: "100%",
    paddingBottom: "calc(env(safe-area-inset-bottom))"
  }
} : {};

function Container(props) {
  let style = {
    backgroundColor: "#fff",
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
    width: "100%",
    maxWidth: 768,
    ...webStyles.container
  };

  if (_reactNative.Platform.OS === "ios") {
    return /*#__PURE__*/_react.default.createElement(_reactNative.KeyboardAvoidingView, {
      behavior: "position"
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      style: style
    }, props.children));
  }

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      maxHeight: "90%",
      ...style
    }
  }, /*#__PURE__*/_react.default.createElement(_reactNative.ScrollView, {
    ref: props.refScrollView
  }, props.children));
}

var _default = ModalContent;
exports.default = _default;